const BG_GRAY = '#ebeef2'
const BG_WHITE = '#fff'
const TEXT_COLOR = '#526484'
const BORDER_OPEN = 'var(--ow-color-primary-700)'
const BORDER_FOCUS = 'var(--ow-color-primary-700)'
const BORDER_NORMAL = 'rgb(var(--ow-border-color))'
const BOX_SHADOW = '0 0 0 3px rgba(var(--ow-primary-color),.10)'

export const customStyles = {
  option: (provided, { isSelected, isFocused, isDisabled }) => ({
    ...provided,
    // eslint-disable-next-line no-nested-ternary
    backgroundColor: isSelected ? BG_GRAY : isFocused ? BG_GRAY : BG_WHITE,
    borderRadius: 'var(--button-border-radius)',
    marginBottom: '0.125rem',
    padding: '0.375rem 0.75rem',
    color: TEXT_COLOR,
    ':active': {
      ...provided[':active'],
      backgroundColor: !isDisabled ? BG_GRAY : undefined,
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: TEXT_COLOR,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '6px',
  }),
  control: (provided, { menuIsOpen, isFocused }) => ({
    ...provided,
    // eslint-disable-next-line no-nested-ternary
    // border: menuIsOpen
    //   ? `1px solid ${BORDER_OPEN}`
    //   : isFocused
    //   ? `1px solid ${BORDER_FOCUS}`
    //   : `1px solid ${BORDER_NORMAL}`,
    borderColor: isFocused ? BORDER_FOCUS : BORDER_NORMAL,
    borderRadius: menuIsOpen
      ? 'var(--button-border-radius) var(--button-border-radius) 0px 0px'
      : 'var(--button-border-radius)',
    boxShadow: isFocused ? BOX_SHADOW : 'none',
    '&:hover': {
      // eslint-disable-next-line no-nested-ternary
      borderColor: menuIsOpen
        ? BORDER_OPEN
        : isFocused
        ? BORDER_FOCUS
        : BORDER_NORMAL,
    },
  }),
  menu: (provided) => ({
    ...provided,
    background: '#ffffff',
    borderRadius: '2px',
    boxShadow: '0px 3px 12px 0px rgba(var(--ow-primary-color),0.1)',
    marginTop: '4px',
    marginBottom: '0',
    zIndex: '1000',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
}
